// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".conversation-type[data-v-84bab856]{margin:20px 0}.conversation-type__hint[data-v-84bab856]{padding:10px 0;color:var(--color-text-light)}\n", ""]);
// Exports
module.exports = exports;
